import { fetchChallenge } from 'features/Backend'
import { GetServerSideProps } from 'next/types'

import { createQueryClient, dehydrateState } from 'config/query'

export { BackendChallenge as default } from 'features/Backend'

export const getServerSideProps: GetServerSideProps = async ({ params }) => {
  const queryClient = createQueryClient()
  const id = typeof params?.question_id === 'string' ? params?.question_id : ''

  if (!id) return { notFound: true }

  await queryClient.prefetchQuery(['backend_challenge', { id }], () =>
    fetchChallenge(id)
  )

  return { props: { ...dehydrateState(queryClient) } }
}
